
 /*

 (▀̿̿Ĺ̯̿▀̿ ̿) -- MISSION: PROTECT THE SECRET DOCUMENTS.

  */

 const SecretService = {
    getSecret: getSecret,
 };

 const SECRET_SIZE = 20;

 function getSecret() {
     const randomBytes = new Uint8Array(SECRET_SIZE);
     window.crypto.getRandomValues(randomBytes);
     return randomBytes;
 }

 export default SecretService;